import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Search } from 'lucide-react';

export const NotFoundPage = () => {
	return (
		<div className="min-h-screen bg-blue-50 flex items-center justify-center px-4">
			<Card className="w-full max-w-md shadow-lg">
				<CardHeader className="text-center">
					<div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
						<Search className="w-8 h-8 text-blue-600" />
					</div>
					<CardTitle className="text-2xl font-semibold text-gray-900">
						Page Not Found
					</CardTitle>
				</CardHeader>
				<CardContent className="text-center space-y-6">
					<div className="space-y-2">
						<p className="text-gray-600">
							The page you're looking for doesn't exist or has been moved.
						</p>
						<p className="text-sm text-gray-500">
							Please check the URL or navigate back to continue.
						</p>
					</div>
				</CardContent>
			</Card>
		</div>
	);
};
